module.exports = __webpack_public_path__ + "img/Fabella.a791d70f.png";